import { render, staticRenderFns } from "./HomeDetail.vue?vue&type=template&id=35d96468&scoped=true&"
import script from "./HomeDetail.vue?vue&type=script&lang=js&"
export * from "./HomeDetail.vue?vue&type=script&lang=js&"
import style0 from "./HomeDetail.vue?vue&type=style&index=0&id=35d96468&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d96468",
  null
  
)

export default component.exports